import { useState } from "react";
import styles from "./header.module.css";
import logo from "../../assets/logo.svg";
import { NavLink, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { MobileMenu } from "../MobileMenu";

const Header = () => {
  const token = useSelector((state) => state.user.token);
  const [isLogged] = useState(false);

  return (
    <header className="shadow-lg sm:m-0 rounded-lg bg-white">
      <section className="">
        <section className="flex items-center justify-between  py-4 lg:px-0 px-2 container mx-auto max-w-[1380px]">
          <div className={styles.logo}>
            <Link to="/">
              <img src={logo} alt="RIBI logo" className={styles.img} />
            </Link>
          </div>

          <nav className={styles.nav}>
            <div className="flex items-center gap-4">
              {!token ? (
                <>
                  <NavLink
                    to="/"
                    className={({ isActive }) =>
                      isActive
                        ? "text-red-500 underline font-bold underline-offset-4 "
                        : "text-[#f6655f] hover:text-red-500 text-base hover:underline hover:underline-offset-4 "
                    }
                  >
                    {" "}
                    Home
                  </NavLink>
                  <NavLink
                    to="/about-us"
                    className={({ isActive }) =>
                      isActive
                        ? "text-red-500 underline font-bold underline-offset-4 "
                        : "text-[#f6655f] hover:text-red-500 text-base hover:underline hover:underline-offset-4 "
                    }
                  >
                    {" "}
                    About
                  </NavLink>
                  <NavLink
                    to="/contact-us"
                    className={({ isActive }) =>
                      isActive
                        ? "text-red-500 underline font-bold underline-offset-4 "
                        : "text-[#f6655f] hover:text-red-500 text-base hover:underline hover:underline-offset-4 "
                    }
                  >
                    {" "}
                    Contact
                  </NavLink>
                  <NavLink
                    to="/need-blood"
                    className={({ isActive }) =>
                      isActive
                        ? "text-red-500 uppercase font-bold outline outline-1 outline-[#f6655f] py-[14px] px-5 rounded-full bg-[#f7c9c7]"
                        : "text-[#f6655f]  hover:text-red-500 py-[14px] px-5 rounded-full text-base  cursor-pointer outline outline-1 outline-[#f6655f] hover:bg-[#f7c9c7]"
                    }
                  >
                    {" "}
                    Need Blood
                  </NavLink>
                </>
              ) : (
                <>
                  <NavLink
                    to="/"
                    className={({ isActive }) =>
                      isActive
                        ? "text-red-500 underline font-bold underline-offset-4 "
                        : "text-[#f6655f] hover:text-red-500 text-base hover:underline hover:underline-offset-4 "
                    }
                  >
                    {" "}
                    Home
                  </NavLink>
                  <NavLink
                    to="/about-us"
                    className={({ isActive }) =>
                      isActive
                        ? "text-red-500 underline font-bold underline-offset-4 "
                        : "text-[#f6655f] hover:text-red-500 text-base hover:underline hover:underline-offset-4 "
                    }
                  >
                    {" "}
                    About
                  </NavLink>
                  <NavLink
                    to="/contact-us"
                    className={({ isActive }) =>
                      isActive
                        ? "text-red-500 underline font-bold underline-offset-4 "
                        : "text-[#f6655f] hover:text-red-500 text-base hover:underline hover:underline-offset-4 "
                    }
                  >
                    {" "}
                    Contact
                  </NavLink>
                  <NavLink
                    to="/dashboard"
                    className={({ isActive }) =>
                      isActive
                        ? "text-red-500 uppercase font-bold outline outline-1 outline-[#f6655f] py-[14px] px-5 rounded-full bg-[#f7c9c7]"
                        : "text-[#f6655f]  hover:text-red-500 py-[14px] px-5 rounded-full text-base uppercase cursor-pointer outline outline-1 outline-[#f6655f] hover:bg-[#f7c9c7]"
                    }
                  >
                    {" "}
                    Account
                  </NavLink>
                </>
              )}
              {!token ? (
                <>
                  {isLogged ? (
                    <>
                      <NavLink
                        to="/dashboard"
                        className={({ isActive }) =>
                          isActive
                            ? "text-red-500 uppercase font-bold outline outline-1 outline-[#f6655f] py-[14px] px-5 rounded-full bg-[#f7c9c7]"
                            : "text-white  hover:text-red-500 py-[14px] px-5 rounded-full text-base hover:font-bold uppercase cursor-pointer outline outline-1 outline-[#f6655f] bg-[#f6655f] hover:bg-[#f7c9c7]"
                        }
                      >
                        {" "}
                        donate blood
                      </NavLink>
                    </>
                  ) : (
                    <>
                      <NavLink
                        to="/auth"
                        className={({ isActive }) =>
                          isActive
                            ? "text-red-500 uppercase font-bold outline outline-1 outline-[#f6655f] py-[14px] px-5 rounded-full bg-[#f7c9c7]"
                            : "text-white   py-[14px] px-5 rounded-full text-base uppercase cursor-pointer outline outline-1 outline-[#f6655f] bg-[#f6655f] hover:bg-[#f64645]"
                        }
                      >
                        {" "}
                        donate blood
                      </NavLink>
                    </>
                  )}
                </>
              ) : null}
            </div>
          </nav>
          <div className={styles.hamburger}>
            <MobileMenu />
          </div>
        </section>
      </section>
    </header>
  );
};

export default Header;
